import { ICart } from "../../../utils/types";

export const calculateCheckoutTotals = (cart: ICart, isFreeDelivery = false) => {
  const productSubtotal = cart?.products?.reduce((sum, product) => {
    const price = Number(product?.newPrice ?? product?.productPrice ?? 0) || 0;
    const quantity = Number(product?.productQty ?? 0) || 0;
    return sum + price * quantity;
  }, 0) ?? 0;

  const deliveryFee = cart?.delivery ? Number(cart.delivery.price ?? 0) : 0;
  const amountBeforeDiscount = productSubtotal + (isFreeDelivery ? 0 : deliveryFee);
  const discountUsed = Number(cart?.discount ?? 0) || 0;
  const totalToCollect = amountBeforeDiscount - discountUsed;

  return {
    productSubtotal,
    deliveryFee,
    amountBeforeDiscount,
    discountUsed,
    totalToCollect,
  };
};
